import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    username: null,
    userHash: null,
    authenticated: false,
    limitNotification: false
  },
  mutations: {
    setUsername(state, value) {
      state.username = value;
    },
    setUserHash(state, value) {
      state.userHash = value;
    },
    authenticate(state, value) {
      state.authenticated = value;
    },
    limitNotification(state, value) {
      state.limitNotification = value;
    }
  },
  getters: {
    roomAccess(state) {
      return state.authenticated
    }
  }
})

export default store;